import { render, staticRenderFns } from "./studentPractice.vue?vue&type=template&id=40f83599&scoped=true"
import script from "./studentPractice.vue?vue&type=script&lang=js"
export * from "./studentPractice.vue?vue&type=script&lang=js"
import style0 from "./studentPractice.vue?vue&type=style&index=0&id=40f83599&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40f83599",
  null
  
)

export default component.exports